import { CasinoLobbyCategory, CasinoPageTab } from "../../http/protocol";

/**
 * The tab with a saved category in place of its copy, matched by id, or appended when absent. A category
 * is reported saved more than once (on the save, again once its SEO saves, and on each retry), so a new
 * category must be appended only the first time.
 */
export const withSavedCategory = (tab: CasinoPageTab | undefined, category: CasinoLobbyCategory): CasinoPageTab => {
  const categories = [...(tab?.categories ?? [])];
  const categoryIndex = categories.findIndex((existing) => existing.id === category.id);
  if (categoryIndex < 0) {
    categories.push(category);
  } else {
    categories.splice(categoryIndex, 1, category);
  }
  return { ...tab, translations: tab?.translations ?? {}, categories };
};
